{
  "nav": {
    "home": "Home",
    "services": "Services",
    "philosophy": "Philosophy",
    "about": "About Me",
    "contact": "Contact"
  },
  "seo": {
    "home": {
      "title": "Gerardo Martínez Junco | Dark Lynx Protocol",
      "desc": "Official site of Gerardo Martínez Junco, programmer in Querétaro and founder of Dark Lynx Protocol. Affordable websites for businesses that need fast sites, technical SEO, and custom systems."
    },
    "services": {
      "title": "Programmer in Querétaro and affordable websites | Dark Lynx Protocol",
      "desc": "Programmer in Querétaro for small businesses: affordable websites, branded landing pages, custom systems, SEO rescue, speed, and secure integrations."
    },
    "philosophy": {
      "desc": "How we work at Dark Lynx Protocol: direct communication, real speed, maintainable code, technical SEO, and web solutions built to grow without endless patches.",
      "title": "Clear, fast web development with maintainable code | Dark Lynx Protocol"
    },
    "about": {
      "desc": "Meet Gerardo Martínez Junco, programmer in Querétaro and founder of Dark Lynx Protocol: fullstack web developer with over 10 years of experience in fast websites, custom systems, and business platforms.",
      "title": "Gerardo Martínez Junco, programmer in Querétaro | Dark Lynx Protocol"
    },
    "contact": {
      "title": "Quote your website or custom system | Dark Lynx Protocol",
      "desc": "Tell us about your web project. We reply within 24 hours to review your website, system, online store, integration, or technical SEO improvement."
    },
    "journal": {
      "title": "Technical dev log | Dark Lynx Protocol",
      "desc": "Private development log with tools, projects, and lessons learned from Dark Lynx Protocol."
    },
    "landingPages": {
      "title": "Affordable websites for small businesses | Dark Lynx Protocol",
      "description": "Affordable websites that are fast, clear, and prepared with base SEO. Landing pages for businesses that need to look professional and turn visitors into contacts."
    }
  },
  "cta": {
    "startProtocol": "START_PROTOCOL",
    "tellMeProject": "I want an idea for my business",
    "viewPhilosophy": "See how we work",
    "viewAllServices": "See services",
    "sendData": "TRANSMIT_DATA",
    "sending": "TRANSMITTING...",
    "viewLandingPages": "See landing pages",
    "requestQuote": "Request a quote",
    "talkBusiness": "I want an idea for my business"
  },
  "footer": {
    "brand": "DARK LYNX PROTOCOL",
    "status": "[SYSTEM_STABLE]"
  },
  "home": {
    "hero": {
      "badge": "BOUTIQUE_WEB_STUDIO",
      "title": "Your business deserves to look like a <span class=\"text-accent text-glow\">brand</span>.",
      "description": "Dark Lynx Protocol is a programmer-led studio in Querétaro that builds affordable websites that are fast, clear, with visual identity, base SEO, and direct contact flows for businesses that want to stop looking improvised online.",
      "ctaPrimary": "I want an idea for my business",
      "ctaSecondary": "See services"
    },
    "problem": {
      "overline": "THE PROBLEM",
      "title": "Why your current website isn't bringing you sales",
      "description": "Buying generic templates or hiring agencies that paste thousands of lines of copied code usually ends the same way: a slow site that's expensive to maintain, and that nobody, not you, not your provider, can actually explain how it works.",
      "alert": "[WARNING_SYMPTOM]",
      "alertList": [
        "Your page takes more than 3 seconds to load, and almost half of visitors leave before seeing it.",
        "The code is so tangled that any small change costs a fortune or breaks something else.",
        "You depend on third-party plugins that get outdated, break, or charge you monthly.",
        "Your budget goes to patches that never actually solve the underlying problem."
      ],
      "protocol": "[THE_PROTOCOL]",
      "protocolList": [
        "Your page loads in under a second and looks complete on the first try, no jumps or waits.",
        "Clean, organized code that any developer can read and modify without fear of breaking something.",
        "Few external dependencies. If something breaks, you don't depend on a third party to fix it.",
        "We hand you a site you can extend and maintain yourself, with clear documentation."
      ]
    },
    "services": {
      "overline": "COMMERCIAL PATHS",
      "title": "Choose where to start",
      "description": "Not every business needs the same thing. As a programmer in Querétaro, I help you choose a clear path based on your moment: professional presence, custom system, or rescue for a site that already exists.",
      "list": [
        {
          "icon": "Layout",
          "title": "Affordable websites with identity",
          "description": "For businesses that need an affordable website, a professional look, clear offers, and messages without building a huge platform.",
          "href": "/servicios/landing-pages",
          "cta": "See landing pages"
        },
        {
          "icon": "Layers",
          "title": "Systems to operate better",
          "description": "For processes that already eat your time: bookings, catalogs, forms, internal panels, automations, and integrations.",
          "href": "/servicios",
          "cta": "See services"
        },
        {
          "icon": "Search",
          "title": "SEO and speed rescue",
          "description": "For existing sites that load slowly, do not show up on Google, or feel patched together. We review, clean, and improve what is worth keeping.",
          "href": "/servicios",
          "cta": "Review options"
        }
      ]
    },
    "commercialPaths": [
      {
        "title": "Professional presence",
        "description": "An affordable, fast, clear website ready for customers to contact you.",
        "link": "/servicios/landing-pages"
      },
      {
        "title": "Business systems",
        "description": "Internal tools, panels, and automations that reduce manual work.",
        "link": "/servicios"
      },
      {
        "title": "SEO rescue",
        "description": "Technical improvements for pages that are slow, messy, or invisible on Google.",
        "link": "/servicios"
      }
    ]
  },
  "services": {
    "hero": {
      "overline": "SERVICES",
      "title": "Affordable websites without inflated packages",
      "description": "Each service starts from a concrete problem: working with a programmer in Querétaro to get an affordable, professional website, sell better, organize processes, or rescue a page that no longer works as it should."
    },
    "modules": [
      {
        "icon": "Layout",
        "title": "Affordable websites with identity",
        "description": "An affordable website focused on explaining your offer, building trust, and moving visitors toward contact. Ideal for local businesses, professional services, and specific campaigns.",
        "tags": [
          "Visual identity",
          "Base SEO",
          "Direct contact",
          "Mobile first"
        ],
        "href": "/servicios/landing-pages",
        "cta": "See details"
      },
      {
        "icon": "Layers",
        "title": "Custom systems and platforms",
        "description": "Bookings, catalogs, admin panels, advanced forms, and integrations when your business needs more than an informational page.",
        "tags": [
          "Admin panel",
          "Database",
          "Automations",
          "Integrations"
        ],
        "href": "/contacto",
        "cta": "Talk through my case"
      },
      {
        "icon": "Search",
        "title": "Technical SEO and speed",
        "description": "We review performance, structure, metadata, indexing, and content so your site loads better and Google understands what you offer.",
        "tags": [
          "Core Web Vitals",
          "Metadata",
          "Indexing",
          "Diagnostics"
        ],
        "href": "/contacto",
        "cta": "Request review"
      },
      {
        "icon": "Shield",
        "title": "Secure payments and integrations",
        "description": "We connect forms, payments, APIs, CRMs, or tools you already use while keeping security, maintenance, and technical clarity in mind from the start.",
        "tags": [
          "Payments",
          "APIs",
          "Forms",
          "Security"
        ],
        "href": "/contacto",
        "cta": "Quote integration"
      }
    ],
    "tech": {
      "overline": "TOOLBOX",
      "title": "The right tools for each project",
      "description": "We choose the technology based on what your business needs, not the other way around. We always aim for a site that is fast, easy to maintain, prepared for technical SEO, and does not lock you into a single vendor."
    },
    "cta": {
      "title": "Ready to stop fighting with your website?",
      "description": "Book a no-strings-attached call. We look at your current situation, tell you what makes sense, and give you a clear quote before you decide anything."
    }
  },
  "philosophy": {
    "hero": {
      "overline": "HOW WE WORK",
      "title": "How we think about every project",
      "description": "Four simple ideas that guide everything we do. If you read them and feel they don't match what you need, we're probably not the right studio for you. And that's fine."
    },
    "principles": [
      {
        "number": "01",
        "title": "We talk straight, no runaround",
        "description": "We tell you things as they are. If your idea works, we tell you why. If there's a risk, we say so too. And if a simple solution solves your problem, we won't sell you something more expensive just to charge more.",
        "span": "col-span-3"
      },
      {
        "number": "02",
        "title": "Speed matters, a lot",
        "description": "A fast page isn't vanity: it's more sales, more people who stick around, and better Google ranking. We take care of every technical detail so your site opens well on any phone and connection.",
        "span": "col-span-3"
      },
      {
        "number": "03",
        "title": "Code you can touch without fear",
        "description": "We write everything in an organized, documented way. If a year from now another developer, or you yourself, needs to change something, they'll know exactly where to touch and what happens when they do.",
        "span": "col-span-4"
      },
      {
        "number": "04",
        "title": "We recommend what you need, not what makes us the most money",
        "description": "If what you need is solved by a simple page, we won't push you toward an expensive platform. Your business working well matters more to us than a big project.",
        "span": "col-span-2"
      }
    ],
    "comparison": {
      "overline": "THE DIFFERENCE",
      "headerTitle": "How we work, compared to a traditional agency",
      "description": "Agencies aren't bad. It's that each model works for different things. This is the practical difference between working with a small studio and a large agency.",
      "traditional": {
        "title": "Large traditional agency",
        "items": [
          "Dozens of people on your project, with several layers between you and the person writing the code.",
          "Generic templates forced to fit, with duplicated styles and classes everywhere.",
          "Dozens of external tools installed 'just in case', making your page slow and expensive to run.",
          "Long delivery times, with internal approval layers that delay every change.",
          "Any small change is quoted separately and goes through a slow process to be resolved."
        ]
      },
      "boutique": {
        "title": "Boutique studio (Dark Lynx)",
        "items": [
          "You talk directly to the person writing your code. No middlemen.",
          "We build from scratch, designed for your business, with no forced adaptations.",
          "We only install what's actually going to be used. Your page stays clean and fast.",
          "Deliveries in short milestones, with clear dates and direct communication.",
          "We leave everything documented and organized so you can make changes yourself."
        ]
      }
    },
    "quote": {
      "text": "We prefer taking things out of a project rather than adding them. Every line of code that doesn't need to be there is a line that can break, cost more, or get in the way the day someone needs to understand how it works.",
      "author": "DARK LYNX PROTOCOL"
    }
  },
  "about": {
    "profile": {
      "role": "Programmer in Querétaro, fullstack web developer, and technical partner",
      "bio": "I have spent over 10 years building websites, platforms, and systems for companies and businesses. I am a programmer in Querétaro focused on fast sites, technical SEO, maintainable code, secure integrations, and solutions you can keep using without endless patchwork. If your business needs an online presence that actually works, not just looks pretty, reach out and let us talk.",
      "secretButton": "Secret Dev Diary"
    },
    "trajectory": {
      "overline": "TRAJECTORY",
      "title": "Project history and experience",
      "description": "A timeline of the projects and companies that shaped me as a professional. What I learned at each stop is part of what your business gets when you work with me.",
      "timeline": [
        {
          "year": "2026 - Present",
          "title": "Studio founder",
          "company": "Dark Lynx Protocol",
          "description": "I run a small studio focused on building sites and platforms with no technical shortcuts. Every project ships fast, is easy to maintain, and leaves the client in control of what they paid for."
        },
        {
          "year": "2026 - Present",
          "title": "Software developer",
          "company": "Ria Money Transfer",
          "description": "I work on money transfer platforms for one of the largest companies in the world. That's where I learned what it means to handle millions of operations without the system falling apart, and I bring that to your projects."
        },
        {
          "year": "2020 - 2025",
          "title": "Senior developer",
          "company": "MTech-Systems",
          "description": "I led the development of regulatory systems for the agricultural sector in Brazil, and mentored other developers. That's where I confirmed that clean code and honest mentoring are the foundation of projects that last."
        },
        {
          "year": "2015 - 2020",
          "title": "Freelance developer",
          "company": "Independent projects",
          "description": "I designed and launched several online stores with secure payments and dynamic catalogs. That's where I learned to talk to non-technical clients and deliver results without losing my mind."
        },
        {
          "year": "2018",
          "title": "Web developer",
          "company": "Probusiness",
          "description": "My first formal job in the industry: designing and maintaining product portals. That's where I learned to do a lot with little, and to value every minute of a project."
        }
      ]
    },
    "status": {
      "stable": "ACTIVE",
      "accepting": "TRUE",
      "integrity": "100% SECURE",
      "focusTitle": "RIGHT NOW:",
      "focus": [
        "Building platforms that handle the growth of mid-sized businesses, from Querétaro.",
        "Designing fast, clear interfaces that work perfectly on mobile, where most of your customers are.",
        "Connecting sites to payment systems, databases, and the tools your business already uses.",
        "Helping businesses that already have a site but it's slow, broken, or simply doesn't show up on Google."
      ],
      "connectTitle": ">_ INITIATE_CONNECTION",
      "linkDesc": "Reach me on:",
      "journal": "Dev Journal"
    }
  },
  "contact": {
    "hero": {
      "overline": "CONNECTION",
      "title": "Tell us about your project",
      "description": "Send us a message with the general idea of what you need. We reply within 24 hours to schedule a no-strings-attached call and review together what makes sense."
    },
    "form": {
      "name": "USER_ID (Name)",
      "email": "ENCRYPTED_MAIL (Email)",
      "subject": "SUBJECT_CODE",
      "message": "PAYLOAD (Message)",
      "directLineBefore": "or if you prefer, reach us directly at",
      "directLineAfter": "— we reply within 24 hours",
      "success": "PROTOCOL COMPLETED. Data transmitted successfully.",
      "error": "TRANSMISSION_ERROR. Please try again."
    }
  },
  "journal": {
    "title": "Dev log",
    "subtitle": "Notes on projects, tools, and things I'm learning along the way.",
    "badge": "ACCESS_GRANTED",
    "emptyState": "No entries found in the archive.",
    "loadMore": "Load more",
    "endOfFeed": "End of log",
    "loadError": "Error loading more entries",
    "retry": "Retry"
  },
  "landingPages": {
    "hero": {
      "overline": "LANDING PAGES",
      "title": "Affordable websites for small businesses",
      "description": "An affordable, focused, fast, clear website so your business looks professional, explains what it offers, and turns visits into real messages."
    },
    "included": {
      "overline": "WHAT IS INCLUDED",
      "title": "The essentials to look professional from the first click",
      "items": [
        {
          "icon": "Palette",
          "title": "Applied visual identity",
          "description": "Colors, hierarchy, sections, and visual style aligned with your brand, not a generic template."
        },
        {
          "icon": "Smartphone",
          "title": "Mobile first design",
          "description": "The page is designed for phones first, because that is where most customers arrive."
        },
        {
          "icon": "Search",
          "title": "Base SEO",
          "description": "Title, description, semantic structure, Open Graph, canonical, and clear content for local searches."
        },
        {
          "icon": "MessageCircle",
          "title": "Direct contact",
          "description": "Visible CTA toward a form, WhatsApp, or the channel that makes the most sense for your business."
        }
      ]
    },
    "packages": {
      "overline": "PACKAGES",
      "title": "Three levels based on your moment",
      "items": [
        {
          "name": "Presence",
          "price": "From an affordable, focused website",
          "description": "For validating an offer, launching your professional presence, or replacing an improvised page without inflating the budget.",
          "features": [
            "Clear hero",
            "Base sections",
            "Initial SEO",
            "Form or direct CTA"
          ]
        },
        {
          "name": "Conversion",
          "price": "Complete landing page to sell",
          "description": "For campaigns, services that need more explanation, or businesses that need more trust before contact.",
          "features": [
            "Commercial copy",
            "Trust blocks",
            "FAQ",
            "CTA optimization"
          ]
        },
        {
          "name": "Protocol",
          "price": "Landing page + light system",
          "description": "For when the landing page needs advanced forms, automations, or data connections.",
          "features": [
            "Integrations",
            "Conversion events",
            "Initial automation",
            "Technical documentation"
          ]
        }
      ]
    },
    "process": {
      "overline": "PROCESS",
      "title": "How we work without making it heavy",
      "steps": [
        {
          "number": "01",
          "title": "We understand your offer",
          "description": "We clarify what you sell, who you talk to, and what action the visitor should take."
        },
        {
          "number": "02",
          "title": "We design the route",
          "description": "We define sections, messages, CTAs, and visual structure before writing code."
        },
        {
          "number": "03",
          "title": "We build and tune",
          "description": "We create the landing page, review mobile, speed, base SEO, and conversion details."
        },
        {
          "number": "04",
          "title": "We hand over control",
          "description": "You get the page ready, clear, and documented so you do not depend on weird patches."
        }
      ]
    },
    "faq": {
      "overline": "FAQ",
      "title": "Common questions",
      "items": [
        {
          "question": "Does this work if I am just starting?",
          "answer": "Yes. A good landing page helps explain your offer and build trust even if you do not need a big site yet."
        },
        {
          "question": "Can I add more sections later?",
          "answer": "Yes. The idea is to start focused and grow without throwing the previous work away."
        },
        {
          "question": "Does it include domain and hosting?",
          "answer": "I can guide you through domain, hosting, and deployment. We define it case by case so you do not buy what you do not need."
        },
        {
          "question": "Can it connect to WhatsApp or a form?",
          "answer": "Yes. The CTA can go to WhatsApp, a form, email, or a more advanced integration."
        }
      ]
    },
    "cta": {
      "title": "Want a landing page that actually feels like your business?",
      "description": "Tell me what you sell and I will propose a simple route to start without inflating the project.",
      "button": "I want an idea for my business"
    }
  }
}
